import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useEffect, useState, useRef } from "react";
import { useLanguage } from '../../context/LanguageContext';
import { useNavigate, useNavigation } from 'react-router-dom';

const CreativeAgencyTwoProduct = () => {
  const [isClient, setIsClient] = useState(false);
  const swiperRef = useRef(null);
  const { t } = useLanguage();
  const navigation = useNavigate()

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const products = [
    {
      image: "/assets/img/rightee2.png",
      alt: "Rightee",
      link: '/cases/rightee',
    },
    {
      image: "/assets/img/cardiohome.png",
      alt: "Cardiohome",
      link: '/cases/cardiohome'
    },
    {
      image: "assets/img/grupovisco.png",
      alt: "Visco",
      link: '/cases/grupovisco'
    }
    
  ];

  return (
    <>
      {isClient && (
        <div className="ca-two-product-area pt-60 pb-120 overflow-hidden">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center mb-4">{t('cases.title')}</h2>
                <div className="ca-two-product-slider swiper">
                  <Swiper
                    ref={swiperRef}
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={3}
                    loop={true}
                    // pagination={{ clickable: true }}
                    // navigation
                    autoplay={{
                      delay: 3000, // Delay between slides in ms
                      disableOnInteraction: false, // Continue autoplay after user interactions
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      1000: {
                        slidesPerView: 3,
                      },
                      1200: {
                        slidesPerView: 4,
                      },
                    }} // Optional: adds navigation arrows
                  >
                    {products.map((product, index) => (
                      <SwiperSlide key={index}>
                        <div style={{ height: "300px", cursor: "pointer" }} onClick={() => {navigation(product.link)}} className="ca-two-product-item bg-white ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 mt-20">
                          <img
                            src={product.image}
                            alt={product.alt}
                            className="ca-two-product-img"
                            style={{ width: "150px" }}
                          />
                          <h5 className="ca-two-body-clr-two fs-20 mb-20 mt-20">
                            {t(`cases.products.${index}.title`)}
                          </h5>
                          <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                            {t(`cases.products.${index}.description`)}
                          </p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreativeAgencyTwoProduct;
